import React, { useEffect, useState } from 'react';
function formatPart(n: number): string {
  return n.toString().padStart(2, '0');
}
function getEndOfDay(): number {
  const now = new Date();
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
  return end.getTime();
}
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 0,
    s: 0
  });
  useEffect(() => {
    const update = () => {
      const remaining = Math.max(0, getEndOfDay() - Date.now());
      const h = Math.floor(remaining / (1000 * 60 * 60));
      const m = Math.floor(remaining % (1000 * 60 * 60) / (1000 * 60));
      const s = Math.floor(remaining % (1000 * 60) / 1000);
      setTimeLeft({
        h,
        m,
        s
      });
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);
  const Box = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-72">
      <div className="bg-red-600 text-white font-black text-sm md:text-2xl font-display rounded md:rounded-md px-1.5 py-0.5 md:px-2.5 md:py-1 min-w-[28px] md:min-w-[44px] text-center shadow-sm tabular-nums" data-id="element-73">
        {formatPart(value)}
      </div>
      <span className="text-[8px] md:text-[9px] font-bold text-red-700 uppercase tracking-wide mt-0.5" data-id="element-74">
        {label}
      </span>
    </div>;
  return <div className="rounded-lg md:rounded-xl bg-red-50 border border-red-200 px-2.5 py-1.5 md:px-4 md:py-2 flex items-center justify-between gap-2" data-id="element-75">
      <div className="text-left" data-id="element-76">
        <div className="text-[10px] md:text-sm font-black text-red-700 uppercase tracking-tight leading-tight" data-id="element-77">
          ⏰ Oferta termina en:
        </div>
        <div className="text-[9px] md:text-xs text-red-600/80 font-medium leading-tight" data-id="element-78">
          Precio especial por tiempo limitado
        </div>
      </div>
      <div className="flex items-end gap-1 md:gap-1.5 shrink-0" data-id="element-79">
        <Box value={timeLeft.h} label="hs" data-id="element-80" />
        <span className="text-red-600 font-black text-sm md:text-xl pb-2 md:pb-3" data-id="element-81">
          :
        </span>
        <Box value={timeLeft.m} label="min" data-id="element-82" />
        <span className="text-red-600 font-black text-sm md:text-xl pb-2 md:pb-3" data-id="element-83">
          :
        </span>
        <Box value={timeLeft.s} label="seg" data-id="element-84" />
      </div>
    </div>;
}